/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const PartnerCRMPage = lazyLoad(
  () => import('./index'),
  module => module.PartnerCRMPage
);
